import { Box, Button, Flex, Image, Text, Tooltip } from "@chakra-ui/react";
import { useRef } from "react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";

function FileUploaderPro({ file, onChange, title }) {
  const fileInputRef = useRef(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const fileList = event.dataTransfer.files;
    if (fileList.length > 0) {
      onChange(fileList[0]);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleFileInputChange = (event) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      onChange(fileList[0]);
    }
  };

  const handleDeleteClick = () => {
    onChange(null);
    fileInputRef.current.value = "";
  };

  return (
    <Flex
      p="10px"
      align="center"
      gap="1rem"
      border={file ? "2px solid green" : "2px solid red"}
      borderRadius="5px"
    >
      {file ? (
        <DeleteIcon onClick={handleDeleteClick} cursor="pointer" />
      ) : (
        <AddIcon onClick={handleBrowseClick} cursor="pointer" />
      )}
      <Flex
        w="300px"
        align="center"
        borderStyle="dashed"
        borderWidth="2px"
        borderColor={"gray.400"}
        p={4}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleBrowseClick}
        cursor="pointer"
        gap="1rem"
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileInputChange}
          style={{ display: "none" }}
        />
        <Text fontSize="15px" fontWeight="600">
          {file ? file.name : title}
        </Text>
      </Flex>
    </Flex>
  );
}

export default FileUploaderPro;
